import { Product } from "../data/products";
import { brandConfig } from "../config/brandConfig";
import { Helmet } from "react-helmet-async";

type ProductSEOProps = {
  product: Product;
  productsRelatedTo: Product[];
};

export function ProductSEO({ product, productsRelatedTo }: ProductSEOProps) {
  const { NDD, brandName } = brandConfig;
  const { name, images, short, sku, slug } = product;
  const prices = product.revendeurs.map((r) => r.prix);
  const lowPrice = Math.min(...prices);
  const highPrice = Math.max(...prices);
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": `${NDD}/produits/${slug}#product`,
    name: name,
    image: images.map((img: string) => `${NDD}${img}`),
    description: short,
    brand: {
      "@type": "Brand",
      name: brandName,
    },
    manufacturer: {
      "@type": "Organization",
      "@id": `${NDD}/#organization`,
    },
    sku: sku,
    category: "Armoire à fusils",
    offers: {
      "@type": "AggregateOffer",
      url: `${NDD}/produits/${slug}`,
      priceCurrency: "EUR",
      lowPrice,
      highPrice,
      offerCount: product.revendeurs.length,
      availability: "https://schema.org/InStock",
    },
    additionalProperty: Object.entries(product.specs).map(([key, value]) => ({
      "@type": "PropertyValue",
      name: key,
      value: value,
    })),
    hasDigitalDocument: {
      "@type": "DigitalDocument",
      name: "Fiche technique KaiserSafe 6 armes",
      url: `${NDD}${product.ficheTechnique}`,
    },
    isRelatedTo: productsRelatedTo.map((product) => ({
      "@type": "Product",
      "@id": `${NDD}/produits/${product.slug}#product`,
      name: product.name,
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
  );
}
